import React, { FunctionComponent } from 'react';

import { LayoutSettings } from '@paragon/contract-library';

import { BevelCutTypePreferenceSelect } from '../controls/BevelCutTypePreferenceSelect';
import { SettingsDialogColumn } from '../SettingsDialogContainer';
import { SettingsControlProps } from '../types';

type Props = SettingsControlProps<LayoutSettings>;

export const LayoutSettingsColumn: FunctionComponent<Props> = ({ value, onChange }) => (
  <SettingsDialogColumn title="Layout Settings">
    <BevelCutTypePreferenceSelect
      value={value.bevelCutTypePreference}
      onChange={(bevelCutTypePreference) => onChange({ bevelCutTypePreference })}
    />
  </SettingsDialogColumn>
);
